// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"beb_a bht_b bht_va bht_rv bht_rw bht_vu","PanelFooter--link":"beb_b"};